import React from 'react';

export const RenderFastonCovered4_8 = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => {
  return (
    <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
      <g style={{ transformOrigin: '0px 150px' }}>
        
        {/* Riempimenti */}
        <path 
          d="M 346 121.166 L 346 -124 L 102.811 -124 L 3.954 -57.766 L 3.954 54.931 L 102.811 121.166 L 346 121.166 Z" 
          fill={color} 
          stroke="none"
        />
        <path 
          d="M -237.26 79.646 L -237.26 -82.48 L -346 -82.48 L -346 79.646 L -237.26 79.646 Z" 
          fill={color} 
          stroke="none"
        />
        <path 
          d="M -237.26 79.646 C -217.49 77.669 -187.83 55.92 -180.91 54.931 L -180.91 -57.766 C -187.83 -59.743 -222.43 -82.48 -237.26 -82.48 L -237.26 79.646 Z" 
          fill={color} 
          stroke="none"
        />
        <path 
          d="M 3.954 54.931 C -59.314 54.931 -168.45 55.26 -180.91 54.931 L -180.91 -57.766 C -171.02 -57.766 -61.291 -57.766 3.954 -57.766 L 3.954 54.931 Z" 
          fill={color} 
          stroke="none"
        />

        {/* Contorni esterni spessi (8px) */}
        <line x1="346" y1="121.166" x2="346" y2="-124" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="346" y1="-124" x2="102.811" y2="-124" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="102.811" y1="-124" x2="3.954" y2="-57.766" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="3.954" y1="54.931" x2="102.811" y2="121.166" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="102.811" y1="121.166" x2="346" y2="121.166" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="-237.26" y1="-82.48" x2="-346" y2="-82.48" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="-346" y1="-82.48" x2="-346" y2="79.646" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="-346" y1="79.646" x2="-237.26" y2="79.646" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <path d="M -237.26 79.646 C -217.49 77.669 -187.83 55.92 -180.91 54.931" stroke="#191919" strokeWidth="8" strokeLinecap="round" fill="none" />
        <path d="M -180.91 -57.766 C -187.83 -59.743 -222.43 -82.48 -237.26 -82.48" stroke="#191919" strokeWidth="8" strokeLinecap="round" fill="none" />
        <line x1="-180.9" y1="54.9" x2="4" y2="54.9" stroke="#191919" strokeWidth="8" strokeLinecap="round" />
        <line x1="-180.9" y1="-57.8" x2="4" y2="-57.8" stroke="#191919" strokeWidth="8" strokeLinecap="round" />

        {/* Linee interne sottili (4px) */}
        <line x1="-237.26" y1="79.646" x2="-237.26" y2="-82.48" stroke="#191919" strokeWidth="4" strokeLinecap="round" />
        <line x1="3.954" y1="54.931" x2="3.954" y2="-57.766" stroke="#191919" strokeWidth="4" strokeLinecap="round" />
        <line x1="-180.91" y1="54.931" x2="-180.91" y2="-57.766" stroke="#191919" strokeWidth="4" strokeLinecap="round" />

      </g>
    </g>
  );
};